export default "__VITE_ASSET__tnlLcuHv__"